module.exports = __webpack_public_path__ + "img/Unit_Guide_shot.8d8f504f.svg";